import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class AuthGuard  {
    private router = inject(Router);
    private authenticationService = inject(AuthenticationService);

    async canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean> {
        return this.authenticationService.isAuthenticatedTryRespawnSession();
    }
}
